<template>
    <v-menu
            v-model="open"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px">
        <template v-slot:activator="{ on }">
            <m-text-field
                    outlined
                    :class="{required}"
                    append-icon="ol-date_range"
                    readonly
                    v-mask="'##/##/####'"
                    v-model="dateBR"
                    @click="open = true"
                    ref="input"
                    v-on="on"
                    v-bind="$attrs">
            </m-text-field>
        </template>
        <v-date-picker
                ref="picker"
                v-model="dateUS"
                no-title
                locale="pt-BR"
                class="datePicker"
                color="white"
                :max="maxDate"
                :min="minDate">
        </v-date-picker>
    </v-menu>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'DateBirthdayField',
    props: {
      value: String,
      minimumAge: { Type: Number, default: 16 },
      maximumAge: { Type: Number, default: 150 }
    },
    data: () => ({
      open: false,
      events: [],
      dateUS: '',
      dateBR: ''
    }),
    computed: {
      required () {
        return this.$attrs.rules && this.$attrs.rules.indexOf(this.$rules.required) >= 0
      },
      maxDate () {
        let date = new Date()
        date.setFullYear(date.getFullYear() - this.minimumAge)
        return date.toISOString().substr(0, 10)
      },
      minDate () {
        let date = new Date()
        date.setFullYear(date.getFullYear() - this.maximumAge + 1)
        date.setDate(date.getDate() + 1)
        return date.toISOString().substr(0, 10)
      }
    },
    watch: {
      open (val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      },
      value () {
        this.refresh()
      },
      dateUS (val) {
        this.$emit('input', val)
        this.dateBR = this.toDateBR(val)
        this.open = false
      }
    },
    mounted () {
      this.refresh()
    },
    methods: {
      validate () {
        this.$refs.input.validate()
      },
      refresh () {
        this.dateUS = this.value || ''
        this.dateBR = this.toDateBR(this.dateUS)
      },
      toDateBR (date) {
        if (date.length === 10) {
          const d = moment(date, 'YYYY-MM-DD')
          return d.isValid() ? d.format('DD/MM/YYYY') : ''
        } else {
          return ''
        }
      }
    }
  }
</script>

<style lang="scss">
    .datePicker .v-date-picker-header {
        background: var(--primary);
        text-transform: capitalize;
    }

    .datePicker .v-date-picker-header .v-btn {
        color: white;
    }

    .datePicker .theme--light .v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) strong:not(:hover) {
        color: white !important;
    }

    .datePicker .theme--light .v-btn--active {
        background: var(--primary) !important;
    }

    .datePicker .theme--light .v-date-picker-table--date .v-btn.v-btn--text {
        border: transparent;
    }

    .datePicker .v-date-picker-years {
        background: var(--primary);
    }
</style>
